import React, {useEffect, useState} from "react";
import ResultsCard from "./ResultsCard";

export default function Result(props) {
    let {searchInput, category} = props;
    let data = props.data?.content?.data;
    let [displayData, setDisplayData] = useState(data);

    useEffect(() => {
        // We truncate data after every update
        setDisplayData(truncateData(data, 8));
    }, [data]);

    if (props.data?.searching || !data) {
        return (
            <div className="results">
                <div className="results__message">Keresés...</div>
            </div>
        );
    }

    if (
        data?.authors?.length <= 0 &&
        data?.publishers?.length <= 0 &&
        data?.speechers?.length <= 0 &&
        data?.series?.length <= 0 &&
        data?.titles?.length <= 0 &&
        data?.genres?.length <= 0 &&
        data?.tags?.length <= 0
    ) {
        return (
            <div className="results">
                <div className="results__notFound">
                    <img src="/images/art/empty-results-art.svg" alt="empty result" />
                    <div className="results__message">Nem található a keresett kifejezés!</div>
                </div>
            </div>
        );
    }

    return (
        <div className="results">
            {displayData?.length > 0 ? (
                <>
                    <div className="results__section">
                        <ul className="results__list">
                            {displayData.map((item, index) => (
                                <ResultsCard
                                    key={index}
                                    item={item}
                                />
                            ))}
                        </ul>
                    </div>
                    <div className="btn results__btn-more">
                        <a href={`/kereses?all=${encodeURIComponent(searchInput)}`}>Összes találat</a>
                    </div>
                </>) : (
                <>
                    <div className="results__notFound books">
                        <img src="/images/art/empty-results-art.svg" alt="empty result" />
                        <div className="results__message">Nincs találat az e-könyvek/hangoskönyvek között.</div>
                    </div>
                </>
            )}
        </div>
    );

    function truncateData(data, maxLength = 10) {
        if (!data) return;

        const result = [];

        for (let key in data.titles) {
            if (result.length === maxLength) break;

            result.push(data.titles[key]);
        }
        return result;
    }
}
